import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'src/app/connection.service';

@Component({
  selector: 'app-withdraw-history',
  templateUrl: './withdraw-history.component.html',
  styleUrls: ['./withdraw-history.component.css']
})
export class WithdrawHistoryComponent implements OnInit {
  withdrawList: any;

  constructor(private conn: ConnectionService, private alert: ToastrService){}
  ngOnInit() {
    this.getWithdraw()
  }

  getWithdraw() {
		this.conn.getUrl('contract/withdraw_list').subscribe((res: any) => {
			if (res.status == true) {
				this.withdrawList = res.data
			}
		})
	}

  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alert.success('Copied to the clipboard');
  }
}
